export const endpoints = {
	auth: {
		login: "/auth/login",
		refresh: "/auth/refresh",
		logout: "/auth/logout",
		me: "/auth/me",
		password: "/auth/me/password",
	},
	clients: {
		list: "/clients",
		create: "/clients",
		detail: (clientId: string) => `/clients/${clientId}`,
		update: (clientId: string) => `/clients/${clientId}`,
	},
	objects: {
		buildings: "/buildings",
		buildingDetail: (id: string) => `/buildings/${id}`,
		blocks: "/blocks",
		blockDetail: (id: string) => `/blocks/${id}`,
		sections: "/sections",
		sectionDetail: (id: string) => `/sections/${id}`,
		rooms: "/rooms",
		roomDetail: (id: string) => `/rooms/${id}`,
		roomPricing: (id: string) => `/rooms/${id}/pricing`,
		calculateSchedule: (id: string) => `/rooms/${id}/calculate-schedule`,
		roomsBulk: "/rooms/bulk",
	},
	files: {
		upload: "/file/upload",
	},
	payments: {
		bankAccounts: "/bank-accounts",
		bankAccountDetail: (id: string) => `/bank-accounts/${id}`,
		cancelledSales: "/payments/cancelled-sales",
		create: "/payments",
		detail: (id: string) => `/payments/${id}`,
		discountScale: "/early-payment-discounts",
		early: "/payments/early",
		refund: (id: string) => `/payments/${id}/refund`,
		schedules: "/payment-schedules",
	},
	sales: {
		list: "/sales",
		create: "/sales",
		detail: (id: string) => `/sales/${id}`,
		cancel: (saleId: string) => `/sales/${saleId}/cancel`,
	},
	sms: {
		balance: "/sms/balance",
		topup: "/sms/balance/topup",
		transactions: "/sms/balance/transactions",
		templates: "/sms/templates",
		templateDetail: (id: string) => `/sms/templates/${id}`,
		autoSettings: "/sms/auto-settings",
		send: "/sms/send",
		batch: "/sms/send/bulk",
		logs: "/sms/logs",
		reports: "/sms/reports",
		detalization: "/sms/detalization",
	},
	users: {
		admin: "/users",
		create: "/users",
		detail: (id: string) => `/users/${id}`,
		update: (id: string) => `/users/${id}`,
		stats: (id: string) => `/users/${id}/stats`,
	},
	organizations: {
		list: "/admin/organizations",
		detail: (id: string) => `/admin/organizations/${id}`,
		toggle: (id: string) => `/admin/organizations/${id}/toggle`,
	},
	contracts: {
		generate: "/contracts/generate",
	},
	organizationsLegacy: "/organisations",
	admin: {
		stats: "/admin/stats",
		organizations: "/admin/organizations",
		organizationDetail: (id: string) => `/admin/organizations/${id}`,
		audit: "/admin/audit",
	},
	roles: {
		list: "/roles",
		create: "/roles",
		detail: (id: string) => `/roles/${id}`,
		update: (id: string) => `/roles/${id}`,
		delete: (id: string) => `/roles/${id}`,
		permissions: "/roles/permissions",
	},
	roleAssignments: {
		list: "/role-assignments",
		detail: (id: string) => `/role-assignments/${id}`,
		byUserRole: (subjectId: string, roleId: string) =>
			`/role-assignments/by-user/${subjectId}/role/${roleId}`,
	},
	leads: {
		list: "/leads",
		create: "/leads",
		detail: (id: string) => `/leads/${id}`,
		status: (id: string) => `/leads/${id}/status`,
	},
	leadStatuses: {
		list: "/lead-statuses",
		create: "/lead-statuses",
		detail: (id: string) => `/lead-statuses/${id}`,
	},
	reports: {
		dashboard: "/reports/dashboard",
		debts: "/reports/debts",
		sales: "/reports/sales",
		rooms: "/reports/rooms",
		managers: "/reports/managers",
	},
} as const;
